import CompanyInfo from "../components/CompanyInfo";
import TogalsSetup from "../components/TogalsSetup";
import { Form, Input } from "antd";
import { useState } from "react";
import DeleteAccount from "../components/DeleteAccount";
import { toast } from "react-toastify";
import { getRoute } from "../api/routes";
import api from "../Interceptor";
import CustomModal from "../components/customModal/customModal";
import ModalFooter from "../components/customModal/modalFooter";

const Settings = () => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isDeleteAccountModalOpen, setIsDeleteAccountModalOpen] =
    useState(false);

  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
  };

  const openDeleteAccountModal = () => {
    setIsDeleteAccountModalOpen(true);
  };

  const closeDeleteAccountModal = () => {
    setIsDeleteAccountModalOpen(false);
  };

  const handleSavePassword = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      toast.error("The two new passwords do not match!");
      return;
    }

    try {
      const response = await api.put(
        getRoute("users", "admin", "self", false, false, "updatePassword"),
        { oldPassword, newPassword, confirmPassword },
      );

      if (response.status === 200) {
        toast.success("Password updated successfully!");
        closePasswordModal();
      } else {
        const message =
          response.data?.error || response.error || "Failed to update password";
        toast.error(message);
      }
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.message ||
        "Error updating password";
      toast.error(message);
    }
  };

  return (
    <div className="font-customFont p-4 min-h-screen">
      {/* Profile Section */}
      <div className="rounded-3xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 p-4 mb-4 flex flex-col gap-6 font-customFont">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-800">
              Profile Information
            </h2>
            <p className="text-sm text-gray-500">
              Manage your personal account details
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
              Full Name
            </p>
            <p className="font-medium text-gray-800">
              {localStorage.getItem("name")}
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
              Email Address
            </p>
            <p className="font-medium text-gray-800 break-all">
              {localStorage.getItem("email")}
            </p>
          </div>
        </div>

        {/* Toggles */}
        {localStorage.getItem("role") ===
          process.env.REACT_APP_ADMIN_ROLE_ID && (
          <div className="border-t pt-4">
            <TogalsSetup />
          </div>
        )}

        {/* Password */}
        <div className="flex items-center justify-between pt-4 border-t">
          <div>
            <p className="font-medium text-gray-800">Password</p>
            <p className="text-sm text-gray-500">
              Change your account password
            </p>
          </div>

          <button
            type="button"
            className="px-5 py-2 rounded-lg bg-themeGradient text-white font-semibold shadow-sm hover:opacity-90 transition"
            onClick={openPasswordModal}
          >
            Update Password
          </button>
        </div>
      </div>

      {/* CompanyInfo Section */}
      {localStorage.getItem("role") === process.env.REACT_APP_ADMIN_ROLE_ID && (
        <CompanyInfo />
      )}
      {/* Delete Account */}
      {localStorage.getItem("role") === process.env.REACT_APP_ADMIN_ROLE_ID && (
        <div className="rounded-2xl border border-red-200 bg-red-50/40 shadow-sm p-4 mb-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 className="text-lg font-semibold text-red-700">
                Danger Zone
              </h2>
              <p className="text-sm text-red-600 mt-1">
                Deleting your account will schedule permanent removal of all
                your data after 29 days.
              </p>
            </div>

            <button
              type="button"
              className="px-5 py-2 rounded-lg bg-red-600 text-white font-semibold shadow hover:bg-red-700 transition"
              onClick={openDeleteAccountModal}
            >
              Delete Account
            </button>
          </div>
        </div>
      )}

      <CustomModal
        isOpen={isDeleteAccountModalOpen}
        onClose={closeDeleteAccountModal}
        modalTitle="Delete Account"
      >
        <DeleteAccount onClose={closeDeleteAccountModal} />
      </CustomModal>
      <CustomModal
        isOpen={isPasswordModalOpen}
        onClose={closePasswordModal}
        modalTitle="Update Password"
      >
        <Form onFinish={handleSavePassword}>
          <Form.Item
            name="oldPassword"
            rules={[
              { required: true, message: "Please input your old password!" },
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="Old Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <Form.Item
            name="newPassword"
            rules={[
              { required: true, message: "Please input your new password!" },
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="New Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your new password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords do not match!"),
                  );
                },
              }),
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="Confirm New Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <ModalFooter onCancel={closePasswordModal} />
        </Form>
      </CustomModal>
    </div>
  );
};

export default Settings;
